import { render, staticRenderFns } from "./feefo-mini-split-tabs.vue?vue&type=template&id=650e58a1&scoped=true&lang=pug&"
import script from "./feefo-mini-split-tabs.vue?vue&type=script&lang=js&"
export * from "./feefo-mini-split-tabs.vue?vue&type=script&lang=js&"
import style0 from "./feefo-mini-split-tabs.vue?vue&type=style&index=0&id=650e58a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e58a1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteFeefoMini: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/site/feefo-mini.vue').default})
